import React, { useEffect, useState, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {DollarSign } from "lucide-react";
import {
  getTaskDetails, addTaskNotes,
  getTaskNotes,
} from "../../actions/userActions/tasks/taskAction";
import { useHistory, useLocation } from "react-router-dom";
import Loader from "../subComponents/Loader";
import { GOOGLE_MAP_API_KEY } from "../../Constatns.js";
import "./TaskDetail.css";
import moment from "moment";
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import Tooltip from '@mui/material/Tooltip';
import TextField from "@mui/material/TextField";
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Button } from "@mui/material";
import {
  updateSubTask
} from "../../actions/userActions/tasks/taskAction";
import { Drawer } from "@mui/material";
import { Slide } from "@mui/material";
import { format } from "date-fns";
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import HrComponent from "../reuse_components/HrComponent";
import MyMap from "../gMap/MyMap";
import GMap from "../gMap/GMap";
import { CalendarFold, Clock, Contact, FlagIcon, ListChecks, LucideClock, LucideListCheck, LucideUser, NotepadText, PencilLine, User, MapPinned, Users, Package, BriefcaseMedical, ListRestartIcon, ListTodo, ListStart, Download, Gauge } from "lucide-react";import Heading6Regular from "../designSystem/Heading6Regular.jsx";
import Textarea from "../designSystem/TextArea.jsx";
import BackNavHeader from "../subComponents/BreadCrumbs/BackNavHeader .jsx";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay.jsx";
import CustomTab from "../designSystem/CustomTab.jsx";
import { t } from "../../locales/translate.js";

const TaskDetail = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [editable, setEditable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editableFieldId, setEditableFieldId] = useState(null);
  const [statusHistory, setStatusHistory] = useState(false);
  const [subtaskView, setsubtaskView] = useState(true);
  const [attachmentView, setAttachmentView] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Sub Tasks");
  const [hoveredAccompanied, setHoveredAccompanied] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const rowData = location.state;
  const icon =
    "https://cdn2.iconfinder.com/data/icons/social-media-8/512/pointer.png";

  const [loadMap, setLoadMap] = useState(false);
  const [remarks, setRemarks] = useState('');

  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);


  const loadGoogleMapScript = (callback) => {
    if (
      typeof window.google === "object" &&
      typeof window.google.maps === "object"
    ) {
      callback();
    } else {
      const googleMapScript = document.createElement("script");
      googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_API_KEY}&libraries=places`;
      window.document.body.appendChild(googleMapScript);
      googleMapScript.addEventListener("load", callback);
    }
  };

  useEffect(() => {
    dispatch(getTaskDetails(rowData?.id));
    loadGoogleMapScript(() => {
      setLoadMap(true);
    });
  // location.key changes on every history.push, ensuring this re-runs
  // even when navigating to the same route with a different task id.
  }, [location.key]);

  const getInitials = (fullName) => {
  if (!fullName) return;
  const words = fullName.trim().split(" ");
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};


  const SubTasksChange = () => {
    setStatusHistory(false);
    setsubtaskView(true);
    setAttachmentView(false);
    setSelectedTab("Sub Tasks");
  };
  const StatusHistoryChange = () => {
    setStatusHistory(true);
    setsubtaskView(false);
    setAttachmentView(false);
    setSelectedTab("Status History");
  };
  const AttachmentChange = () => {
  setAttachmentView(true);
  setsubtaskView(false);
  setStatusHistory(false);
  setSelectedTab("Attachments");
};

  const taskDetails = useSelector((state) => state.tasks_reducer.taskDetails);
  const markerList = [];

  // Check if task is out of bound
  const isOutOfBound = () => {
    if (!taskDetails || taskDetails === "isLoading" || !taskDetails.taskLog) return false;
    
    const completedStatuses = [8, 9, 10]; // doctor-unavailable, visit-complete, refused-to-meet
    
    return taskDetails.taskLog.some(
      (log) => completedStatuses.includes(log.taskStatus) && log.outOfBound === true
    );
  };

    const products = taskDetails.taskProducts || [];

const producrUrls = products.flatMap((product) =>
  (product?.productUrl || "")
    .split(",")
    .map((url) => url.trim())
    .filter((url) => url.length > 0)
);

  taskDetails.length !== 0 &&
    taskDetails !== "isLoading" &&
    taskDetails.taskLog &&
    taskDetails.taskLog.map((e) => {
      if (e.longitude != null && e.latitude != null) {
        markerList.push({
          lat: e.latitude,
          lng: e.longitude,
          icon: icon,
          title: e.taskStatusName,
        });
      }
    });

  const handleEditButtonClick = (subTaskId) => {
    setEditableFieldId(subTaskId);
  };

  const handleCancelClick = () => {
    setEditableFieldId(null);
  };

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

   const handleGoBack = () => {
    history.goBack();
  };

  const handleRemarksSubmit = (subTask) => {
    setLoading(true);
    const body = {
      taskId: subTask.taskId,
      subTaskId: subTask.subTaskId,
      remarks: remarks,
      subTaskName: subTask.subTaskName,
    };
    try {
      dispatch(updateSubTask(body)).then(() => {
        setLoading(false);
        dispatch(getTaskDetails(subTask.taskId));
        setEditableFieldId(null);
      });
    } catch (error) {
      setLoading(false);
      console.error("Error submitting subtask:", error);
    }
  };

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [state, setState] = useState({
    right: false,
  });
  const [taskNote, setTaskNote] = useState("");
  const [newTaskId, setNewTaskId] = useState();

  const toggleDrawer = (anchor, open, id) => (event) => {
    if (id != null && id != undefined) {
      dispatch(getTaskNotes(id));
    }
    setNewTaskId(id);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      setDrawerVisible(true);
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const getNotes = useSelector((state) => state.tasks_reducer.taskNotes);

  const handleCloseDrawer = () => {
    setState({ ...state, right: false });
  };

  const list = (id) => {
    return (
      <div
        role="presentation"
        onClick={(event) => {
          event.stopPropagation();
        }}
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
      >
        <div>
          <div className="notes-header">
            <p className="notes-heading">{t("notes")}</p>
            <Tooltip title="Close Notes" arrow>
              <CloseIcon className="notes-close-icon" onClick={handleCloseDrawer} />
            </Tooltip>
          </div>
          <hr />
          {getNotes === "isLoading"}

          {getNotes === "isLoading" &&
            getNotes.length > 0 &&
            (!getNotes.createdByName ||
              !getNotes.createdDate ||
              !getNotes.note) && <Loader colored={true} />}
          <div className="note-item-scrollable">
          {getNotes !== "isLoading" &&
            getNotes !== undefined &&
            getNotes.map((noteItem) => {
              const nameParts = noteItem.createdByName.split(" ");
              const firstNameInitial = nameParts[0] ? nameParts[0][0] : "";
              const lastNameInitial =
                nameParts.length > 1
                  ? nameParts[nameParts.length - 1][0]
                  : "";

              const formattedDate = format(
                new Date(noteItem.createdDate),
                "EEEE MMMM d, yyyy"
              );

              return (
                <div className="srollable-note-items">
                <div key={noteItem.id} className="note-item">
                  <div className="notes-avatar-wrapper">
                    <p>
                      {firstNameInitial}
                      {lastNameInitial}
                    </p>
                  </div>
                  <div className="note-content">
                    <p className="note-author-name">
                      {noteItem.createdByName}
                    </p>
                    <p className="note-date">{formattedDate}</p>
                  </div>
                  <p className="note-text">
                    {noteItem.note}
                  </p>
                </div>
                </div>
              );
            })}
            </div>

          <div className="note-input-container">
            <Textarea 
            width={"365px"}
             name="Task Note"
             label={t("taskNote")}
             placeholder={t("enterTaskNote")}
             value={taskNote}
             onChange={(e) => setTaskNote(e.target.value)}
            />
            {/* <TextField
              className="note-input-field"
              multiline
              rows={3}
              value={taskNote}
              onChange={(e) => setTaskNote(e.target.value)}
              placeholder="Enter Task Note"
            /> */}
            <Button
              className="note-add-button"
              onClick={() => {
                handleAddNote(id);
              }}
            >
              {t("addNote")}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  function getStatusColor(status) {
    switch (status?.toLowerCase()) {
      case 'created':
        return '#87A2C7';
      case 'in review':
      case 'in-review':
        return '#E1A900';
      case 'in progress':
      case 'in-progress':
        return '#5858D1';
      case 'approved':
        return '#2ECC71';
      case 'completed(doctor-unavailable)':
      case 'completed(visit-complete)':
      case 'completed(refused-to-meet)':
      case 'completed':
        return '#07A74A';
      default:
        return '#6B7280';
    }
  }

  const handleAddNote = async (id) => {
    if (taskNote.trim() !== "") {
      const noteBody = {
        taskId: id,
        note: taskNote,
        createdDate: new Date().toISOString(),
        createdBy: user.result[0].user.id,
        updatedDate: new Date().toISOString(),
        updatedBy: user.result[0].user.id,
      };

      try {
        dispatch(addTaskNotes(noteBody)).then(() => {
          dispatch(getTaskNotes(id));
        })
        setTaskNote("");
      } catch (error) {
        console.error(
          "An error occurred while adding or fetching notes:",
          error
        );
      }
    } else {
      alert("Please enter a note before adding.");
    }
  };

  const renderAccompaniedBy = () => {
  if (!taskDetails.accompaniedBy || taskDetails.accompaniedBy.length === 0) {
    return <span className="not-available-text">Not available</span>;
  }

  if (taskDetails.accompaniedBy.length === 1) {
    return (
      <div className="accompanied-by-container">
        <span className="task-avatar">
          {getInitials(taskDetails.accompaniedBy[0].accompaniedByName)}
        </span>
        <span className="role-name-text">{taskDetails.accompaniedBy[0].accompaniedByName}</span>
      </div>
    );
  }

  const firstPerson = taskDetails.accompaniedBy[0].accompaniedByName;
  const remainingCount = taskDetails.accompaniedBy.length - 1;

  return (
    <div
      className="accompanied-by-container"
      onMouseEnter={() => setHoveredAccompanied(true)}
      onMouseLeave={() => setHoveredAccompanied(false)}
    >
       <span className="assignment_role_badge">
        
      <span className="task-avatar">
        {getInitials(firstPerson)}
      </span>
      <span className="role-name-text">{firstPerson}</span>
       </span>
      <span className="accompanied-counter">+{remainingCount}</span>

      {hoveredAccompanied && (
        <div className="accompanied-dropdown">
          {taskDetails.accompaniedBy.slice(1).map((person, index) => (
            <div key={index} className="accompanied-item">
               <span className="assignment_role_badge">

              <span className="task-avatar">
                {getInitials(person.accompaniedByName)}
              </span>
              {person.accompaniedByName}
               </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const renderProducts = () => {
  if (!taskDetails.taskProducts || taskDetails.taskProducts.length === 0) {
    return <span className="not-available-text">Not available</span>;
  }

  const visibleProducts = taskDetails.taskProducts.slice(0, 3);
  const remainingProducts = taskDetails.taskProducts.slice(3);

  return (
    <div className="product-container" ref={dropdownRef}>
     <span className="product-names">
        {visibleProducts.map(p => p.productName).join(", ")}
      </span>
      
      {remainingProducts.length > 0 && (
        <div className="product-dropdown-wrapper">
          <span
            className="product-counter"
            onClick={() => setIsProductDropdownOpen((prev) => !prev)}
          >
            +{remainingProducts.length}
          </span>

          {isProductDropdownOpen && (
            <div className="product-dropdown">
              {remainingProducts.map((product, index) => (
                <div key={index} className="product-item">
                  {product.productName}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};



useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setIsProductDropdownOpen(false);
    }
  };

  if (isProductDropdownOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [isProductDropdownOpen]);



  return (
    <>
    <LoadingOverlay isVisible={taskDetails === "isLoading"} />
    <div className="task-detail-wrapper">
        <div className="task-detail-header-container">
          <BackNavHeader text={t("taskDetails")} onBack={handleGoBack}/>
          {isOutOfBound() && (
            <span className="out-of-bound-chip">Out of Bound</span>
          )}
        </div>
      <div className="task-detail-outer-div">
        

        {taskDetails !== "isLoading" &&
          taskDetails != undefined &&
          taskDetails.length !== 0 && (
            <div className="task-detail-container">
              {/* Header Section */}
              <div className="task-header-section">
                <div className="task-info-row">
                  <div className="task-info-column">
                    <div className="task-info-labels">
                      <p className="task-label"><BriefcaseMedical   className="task-label-icon" size={16} />{t("doctor")}</p>
                      <p className="task-label"><MapPinned  className="task-label-icon" size={16} />{t("practiceLocation")}</p>
                      <p className="task-label"><User className="task-label-icon" size={16} />{t("assignedBy")}</p>
                      <p className="task-label"><Contact className="task-label-icon" size={16} />{t("assignedTo")}</p>
                      <p className="task-label"><Users className="task-label-icon" size={16} />{t("accompaniedBy")}</p>
                      <p className="task-label"><MapPinned className="task-label-icon" size={16} />Distance</p>
                        <p className="task-label"><Gauge className="task-label-icon" size={16} />Fuel Price</p>    
                    </div>
                    <div className="task-info-values">
                      <p className="task-value">
                        {taskDetails.doctorName || (
                          <span className="not-available-text">Not available</span>
                        )}
                      </p>
                      <p className="task-value">
                        {taskDetails.practiceLocationName || (
                          <span className="not-available-text">Not available</span>
                        )}
                      </p>
                      <p className="task-value">
                        <span className="assignment_role_badge">
                          <span className="task-avatar">  
                            {getInitials(taskDetails.assignedByName)}
                            </span>
                          {taskDetails.assignedByName || (
                            <span className="not-available-text">Not available</span>
                          )}
                          </span>
                      </p>
                      <p className="task-value">
                        <span className="assignment_role_badge">
                         <span className="task-avatar">  
                            {getInitials(taskDetails.assignedToName)}
                            </span>
                        {taskDetails.assignedToName || (
                          <span className="not-available-text">Not available</span>
                        )}
                        </span>
                      </p>
                      <p className="task-value">
                        {renderAccompaniedBy()}
                      </p>
                      <p className="task-value">
                      {taskDetails.distance != null
                        ? `${taskDetails.distance} km`
                        : <span className="not-available-text">Not available</span>}
                    </p>
                     <p className="task-value">
                      {taskDetails.calculateAt != null
                        ? parseFloat(taskDetails.calculateAt).toFixed(2)
                        : <span className="not-available-text">Not available</span>}
                    </p>
                    </div>
                  </div>
                  <div className="task-info-column">
                    <div className="task-info-labels">
                      <p className="task-label"><ListTodo className="task-label-icon" size={16} />{t("status")}</p>
                      <p className="task-label"><ListStart className="task-label-icon" size={16} />{t("priority")}</p>
                      <p className="task-label"><Package className="task-label-icon" size={16} />{t("product")}</p>
                      <p className="task-label"><CalendarFold className="task-label-icon" size={16} />{t("createdOn")}</p>
                      <p className="task-label"><CalendarFold className="task-label-icon" size={16} />{t("visitDate")}</p>
                      
                      <p className="task-label"><DollarSign className="task-label-icon" size={16} />Task Cost</p>
                      </div>
                    <div className="task-info-values">

                      <p className="task-value">
                        <span className="status-text" style={{ color: getStatusColor(taskDetails.statusName) }}>
                          <span className="status-dot" style={{ backgroundColor: getStatusColor(taskDetails.statusName) }}></span>
                          {taskDetails.statusName}
                        </span>
                      </p>

                      <p className="task-value">
                        <span className="priority-text">
                          <FlagIcon size={14} />
                          {taskDetails.priorityName}
                        </span>
                      </p>
                      <p className="task-value">
                        {renderProducts()}
                      </p>
                      <p className="task-value">
                        {taskDetails.createdAt
                          ? moment(taskDetails.createdAt).format("MMM DD, YYYY")
                          : "Not available"}
                      </p>
                      <p className="task-value">
                        {taskDetails.visitDate
                          ? moment(taskDetails.visitDate).format("MMM DD, YYYY")
                          : "Not Available"}
                      </p>
                    <p className="task-value">
                      {taskDetails.pricePerTask != null
                        ? parseFloat(taskDetails.pricePerTask).toFixed(2)
                        : <span className="not-available-text">Not available</span>}
                    </p>
                    </div>
                  </div>
                </div>

                {/* View Notes Button */}
                <div className="view-notes-container">
                  {["right"].map(() => {
                    const isRTL = document.body.dir === "rtl";
                    const anchor = isRTL ? "left" : "right";
                    const slideDirection = isRTL ? "left" : "right";
                   return ( <React.Fragment key={anchor}>
                      {taskDetails !== "isLoading" &&
                        taskDetails != undefined &&
                        taskDetails.length !== 0 && (
                          <>
                            <button
                              className="view-notes-button"
                              onClick={toggleDrawer(anchor, true, taskDetails.id)}
                            >
                              <NotepadText size={16}/>
                              <Heading6Regular text={t("viewNotes")} />
                            </button>
                            <Drawer
                              anchor={anchor}
                              open={state[anchor]}
                              onClose={toggleDrawer(anchor, false)}
                              TransitionComponent={Slide}
                              transitionDuration={500}
                              transitionprops={{ direction: slideDirection }}
                              PaperProps={{ style: { width: "25%" } }}
                              BackdropProps={{
                                style: { backgroundColor: "transparent" },
                              }}
                            >
                              {list(taskDetails.id)}
                            </Drawer>
                          </>
                        )}
                    </React.Fragment>
)})}
                </div>
              </div>

              {/* Tabs Section */}
           
              <div style={{display: "flex", gap: "24px", position: "relative", padding: "0px 25px", borderBottom: "1px solid #DFE4EA"}}>

              <CustomTab
                label={t("subTask")}
                isActive={selectedTab === "Sub Tasks"}
                onClick={SubTasksChange}
                />

              <CustomTab
                label={t("statusHistory")}
                isActive={selectedTab === "Status History"}
                onClick={StatusHistoryChange}
                />

              <CustomTab
                label={t("attachments")}
                isActive={selectedTab === "Attachments"}
                onClick={AttachmentChange}
                />
               
                </div>

              {/* Content Section */}
              <div className="content-section">
                {!statusHistory && subtaskView && taskDetails.taskSubTasks && (
                  <div className="subtasks-grid">
                    {taskDetails.taskSubTasks.map((subTask) => (
                      <div className="subtask-item" key={subTask.subTaskId}>
                        <div className="subtask-header">
                          <p className="subtask-name">
                            {subTask.subTaskName || (
                              <span className="not-available-text">Not available</span>
                            )}
                          </p>
                          <Tooltip title="Edit" arrow>
                            <button
                              className="edit-button"
                              onClick={() =>
                                handleEditButtonClick(subTask.subTaskId)
                              }
                            >
                              <PencilLine size={18} color="#637381"/>
                            </button>
                          </Tooltip>
                        </div>
                        <div className="subtask-content">
                          <Grid container>
                            <Grid item xs={12}>
                              <TextField
                                id={`multiline-flexible-${subTask.subTaskId}`}
                                multiline
                                maxRows={3}
                                variant="standard"
                                defaultValue={subTask.remarks}
                                disabled={editableFieldId !== subTask.subTaskId}
                                fullWidth
                                onChange={(event) =>
                                  handleRemarksChange(event, subTask.subTaskId)
                                }
                                placeholder="add remarks about the subtask here"
                                className="subtask-textarea"
                                InputProps={{
                                  disableUnderline: true,
                                }}
                                sx={{
                                  '& .MuiInputBase-root': {
                                    '& textarea': {
                                      scrollbarWidth: 'none',
                                      '&::-webkit-scrollbar': {
                                        display: 'none',
                                      },
                                      '-ms-overflow-style': 'none',
                                    }
                                  }
                                }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        {editableFieldId === subTask.subTaskId && (
                          <div className="subtask-actions">
                            <button
                              onClick={() => handleRemarksSubmit(subTask)}
                              className="submit-button"
                              disabled={loading}
                            >
                              {loading ? (
                                <Loader />
                              ) : subTask.remarks ? (
                                "Update"
                              ) : (
                                `${t("add")}`
                              )}
                            </button>
                            <button
                              onClick={handleCancelClick}
                              className="cancel-button"
                              style={{ width: document.body.dir === "rtl" ? "119px" : "" }}
                            >
                              {t("cancel")}
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {statusHistory && !subtaskView && taskDetails.taskLog && (
                  <div className="status-history-container">
                    <div className="map-section">
                      {!loadMap ? <Loader /> : <GMap markerList={markerList} taskLog={taskDetails.taskLog} />}
                    </div>
                    <div className="timeline-section">
                      {taskDetails.taskLog.map((log, index) => (
                        <div key={log.id} className="timeline-item">
                          <div className="timeline-line">
                            <div className="timeline-dot" />
                            {index !== taskDetails.taskLog.length && (
                              <div className="timeline-connector" />
                            )}
                          </div>
                          <div className="info-card">
                            <div className="status-text" style={{
                              color: getStatusColor(log.taskStatusName),
                            }}>
                              <ListChecks size={14} />
                              <Heading6Regular text={log.taskStatusName || 'Not available'} />
                            </div>
                            <div className="user-text">
                              <User size={14} />
                              <Heading6Regular text={log.updatedByName || 'Not available'} />
                            </div>
                            <div className="time-text">
                              <Clock size={14} />
                              <Heading6Regular text={log.updatedDate
                                ? moment.utc(log.updatedDate).local().format('lll')
                                : 'Not available'} />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

            {!statusHistory && !subtaskView && selectedTab === "Attachments" && (
                  <div className="attachment-section">
                    {producrUrls.length === 0 ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <p style={{ fontFamily: "Poppins", fontSize: "16px", fontWeight: "500", color: "#999" }}>
                          No attachments found for assigned products
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="attachment-header">
                          {/* <h3>Product Attachments</h3> */}
                        </div>

                        {products.map((product, idx) => {
                          const urls =
                            product?.productUrl
                              ?.split(",")
                              .map((url) => url.trim())
                              .filter((url) => url.length > 0) || [];

                          return (
                            <div className="attachment-product" key={idx}>
                              <strong>{product.productName || product.name}</strong>
                              {urls.length > 0 ? (
                                <ul className="attachment-list">
                                  {urls.map((url, docIdx) => (
                                    <li className="attachment-item" key={docIdx}>
                                      <p style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: "500", color: "#637381" }}>
                                        {url.split("/").pop()}
                                      </p>
                                      <a
                                        href={url}
                                        download
                                        rel="noopener noreferrer"
                                        className="attachment-link"
                                        title={url.split("/").pop()}
                                      >
                                        <Download size={16} className="download-icon" />
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <span className="no-attachments">(No attachments)</span>
                              )}
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                )}

              </div>
            </div>
          )}
      </div>
      </div>
    </>
  );
};

export default TaskDetail;